<template>
  <div class="card flex wrap" :class="{calligraphy: base && base.type == 'calligraphy'}">
    <div class="items" v-for="(item, index) in list" :key="index" @click="toDetails(item)">
      <div class="cardDiv" :style="{ backgroundImage: 'url(' + item.cover_img + ')' }" />
      <img class="cardImg" :data-original="item.cover_img" :src="item.cover_img" :alt="item.name" @error="imgError(item)">
      <div class="marsk flex end" :data-id="item.id">
        <div class="u-info">
          <div class="title ellipsis">{{ item.title }}</div>
          <div class="subs ellipsis">
            <label v-if="item.author">{{ item.author }}</label>
            <span>{{ item.produce_time | date }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import utils from "@/utils"
import defaultImg from '@/assets/images/defaultImg.png';
export default {
  props: {
    list: Array,
    base: Object,
  },
  filters: {
    date(val) {
      return utils.formatDates(val)
    },
  },
  data() {
    return {
      defaultImg
    };
  },
  mounted() {
  },
  methods: {
    toDetails(row) {
      this.$emit('toDetails', row)
    },
  }
};
</script>
<style lang="scss" scoped>
.card {
  margin: 0 -6px;
  max-height: 555px;
  padding: 0 2px;
  overflow: hidden;
  &::after {
    content: "";
    flex-grow: 99999;
  }
  &.calligraphy {
    max-height: 470px;
    .items {
      height: 470px;
    }
  }
  .items {
    position: relative;
    margin: 0 6px 12px;
    height: 270px;
    box-sizing: border-box;
    position: relative;
    flex-grow: 1;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s;
    &:hover {
      box-shadow: 0 4px 10px 0 #0000004d;

      .cardDiv {
        transform: scale(1.1)
      }
    }

    .cardImg {
      height: 100%;
      width: 100%;
      opacity: 0;
    }

    .cardDiv {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      /* display: block; */
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      transition: all 0.3s;
    }
  }
}

</style>